// extracted by mini-css-extract-plugin
export default {"container":"H4-z","returnMutipleItemsNewMethodMessage":"I4-z","categorizedReturnMethods":"J4-z","categorizedReturnMethodTitle":"K4-z","categorizeIcon":"L4-z"};